<template>
  <message-bubble :isMine=isMine :message = message style="border: 1px solid #dedede;cursor: pointer;">
    <template>
      <div style="display: flex;font: -webkit-small-control;align-items: center;" @click="downLoadFile">
        <div style='padding-right: 24px;'>
            <div class="file_title" :title="content.name">{{content.name}}</div>
            <div style="margin-top:5px;color:#999999">{{content.size}}</div>
        </div>
        <div :class="['icon', 'iconfont', content.iconType ,'iconFile']"></div>
    </div>
    </template>
  </message-bubble>
</template>

<script>
import MessageBubble from '../message-bubble'

export default {
  name: 'FileElement',
  components: {
    MessageBubble
  },
  props: {
    isMine: {
      type: Boolean
    },

    message: {
      type: Object,
      required: true,
    },
  },
  computed:{
    content(){
      let content = typeof (this.message.content) == 'object' ? this.message.content : JSON.parse(this.message.content)
      let flietype = content.name.split('.')[content.name.split('.').length -1].toLocaleLowerCase()
      content['iconType'] = flietype.indexOf('pdf')!=-1?'iconpdf':flietype.indexOf('ppt')!=-1?'iconPPT':flietype.indexOf('txt')!=-1?'icontxt':(flietype.indexOf('xls')!=-1 || flietype.indexOf('xlsx') != -1)?'iconexcel':(flietype.indexOf('doc')!=-1 || flietype.indexOf('docx') != -1)?'iconword':'iconweizhiwenjian'
      return content
    }
  },
  methods:{
     downLoadFile(){
       var aEle = document.createElement("a");//创建input对象
       aEle.href = this.content.attachment
       aEle.target = '_blank'
       aEle.download = this.content.name
       document.body.appendChild(aEle);//添加元素
       aEle.click()
       document.body.removeChild(aEle);//删除元素
   }
  }
}
</script>
<style scoped>
.file_title{
  max-width: 240px;
  min-width: 150px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
